import Locale from '@serv/Locale'

export function _resolvePatientJourneyListColumnOfType_payerSlug(column, patientJourney, row) {
    if (!row[column.id] || !row[column.id].value) {
        return
    }

    column.cellText = Locale.getLanguageItemForModelEnumOrUndefined('payer', row[column.id].value)
}
